import React, { useEffect, useRef, useState } from 'react';
import { Toast } from 'primereact/toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import LiveTickerBar from '../../../components/live-ticker-bar/liveTickerBar';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { faChartSimpleHorizontal, faTable } from '@fortawesome/pro-solid-svg-icons';
import '../../market/market.scss'
import PeriodSelection from '../../../components/selections/periodSelection/periodSelection';
import DataTableComponent from '../../../components/dataTables/dataTable';
import StackedBarChart from '../../../components/charts/stackedBarChart/stackedBartChart';
import MultipleDatePicker from '../../../components/pickers/multipleDatePicker';
import moment from 'moment/moment';
import { useSelector } from "react-redux";
import Spinner from '../../../components/spinner';
import NumberFormatter from '../../../formatters/NumberFormatter'
import DateFormatter from '../../../formatters/DateFormatter';
import { MarketSummaryServiceApi, Configuration as MarketQueryConfig } from "../../../services/marketQuery";
import { SecurityDetailServiceApi, Configuration as ActionHubConfig } from "../../../services/actionHub";
import BestWorstHigh from '../../../components/best-worst/BestWorstHigh';
import { APIControl } from '../../../helpers/APIControl';
import { useTranslation } from "react-i18next";
const MarketSummary = () => {
    const { t } = useTranslation();
    const numberFormatter = new NumberFormatter();
    const dateFormatter = new DateFormatter();
    const marketApi = new MarketSummaryServiceApi(new MarketQueryConfig({ basePath: process.env.REACT_APP_MARKET_QUERY_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_MARKET_QUERY_API_BASE_PATH));
    const securityDetailServiceApi = new SecurityDetailServiceApi(new ActionHubConfig({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));


    const user = useSelector((state) => state.auth?.user);
    const token = useSelector((state) => state.auth?.token);
    const accountId = useSelector((state) => state.auth?.accountId);

    //#region  STATE VARIABLES
    const toast = useRef(null);
    const [activePeriod, setActivePeriod] = useState(t('period.daily'));
    const [summaryTableColumnsData, setSummaryTableColumnsData] = useState([]);
    const [columnsDataMostCard, setColumnsDataMostCard] = useState([]);

    const [dailyGainersTable, setDailyGainersTable] = useState([]);
    const [dailyLosersTable, setDailyLosersTable] = useState([]);
    const [highestMarketCapitalizationTable, setHighestMarketCapitalization] = useState([]);
    const [highestTradingValueTable, setHighestTradingValue] = useState([]);


    const [showTable, setShowTable] = useState(true);
    const [firstDate, setfirstDate] = useState(moment().subtract(1, 'months').toDate());
    const [lastDate, setlastDate] = useState(new Date());
    const [ColumnsChartViewData, setColumnsChartViewData] = useState([]);

    const [summaryTableChartData, setSummaryTableChartData] = useState([]);
    const [summaryChartData, setSummaryChartData] = useState([]);
    const [summaryChartValue, setSummaryChartValue] = useState('');
    const [marketSummariesServiceData, setMarketSummariesServiceData] = useState([]);
    const [isLoadingTable, setIsLoadingTable] = useState(true);
    const [isBetweenDateData, setIsBetweenDateData] = useState(false);

    //#endregion STATE VARIABLES

    const periods = [t('period.daily'), t('period.weekly'), t('period.monthly'), t('period.ytd'), t('period.yearly')];
    let initialGainersRTData = false;

    //#region TABLE COLUMNS & DATA

    const summaryTableDataColumns = [
        // { id: 1, field: 'code', displayName: 'Endeks', header: t('tableHeader.index'), isVisible: true, width: '25%', align: 'left', clickable: false, sortable: false },
        { id: 1, field: 'name', displayName: 'Endeks', header: t('tableHeader.index'), isVisible: true, width: '25%', align: 'left', clickable: false, sortable: false },
        { id: 2, field: 'lastDay', displayName: t('tableHeader.date'), header: t('tableHeader.date'), isVisible: true, width: '25%', align: 'center', sortable: false, },
        { id: 3, field: 'lastValue', displayName: 'Son', header: t('tableHeader.last'), isVisible: true, width: '25%', align: 'center', sortable: true, },
        { id: 4, field: 'rocDailyChange', displayName: 'rocDaily', header: t('tableHeader.change'), template: '', isVisible: true, width: '33%', align: 'center', sortable: true },
        { id: 5, field: 'rocWeeklyChange', displayName: 'rocWeekly', header: t('tableHeader.change'), template: '', isVisible: false, width: '33%', align: 'center', sortable: true },
        { id: 6, field: 'rocMonthlyChange', displayName: 'rocMonthly', header: t('tableHeader.change'), template: '', isVisible: false, width: '33%', align: 'center', sortable: true },
        { id: 7, field: 'rocYtdChange', displayName: 'rocYtd', header: t('tableHeader.change'), template: '', isVisible: false, width: '33%', align: 'center', sortable: true },
        { id: 8, field: 'rocAnnualyChange', displayName: 'rocAnnualy', header: t('tableHeader.change'), template: '', isVisible: false, width: '33%', align: 'center', sortable: true },
        { id: 9, field: 'rocBetweenDateChange', displayName: 'rocBetweenDate', header: t('tableHeader.change'), template: '', isVisible: false, width: '33%', align: 'center', sortable: true },
    ];

    const summaryTableDataColumnsChartView = [
        { id: 1, field: 'name', displayName: t('tableHeader.index'), header: t('tableHeader.index'), isVisible: true, width: '50%', align: 'left', sortable: false, },
        { id: 2, field: 'lastDay', displayName: t('tableHeader.date'), header: t('tableHeader.date'), isVisible: true, width: '25%', align: 'center', sortable: false },
        { id: 3, field: 'lastValue', displayName: t('tableHeader.last'), header: t('tableHeader.last'), isVisible: true, width: '25%', align: 'center', sortable: false, },
    ]

    const columnsMostCard = [
        { id: 1, binding: 'symbolCode', header: t('tableHeader.code'), isVisible: true, width: '25%', align: 'left', sortable: false, clickable: true },
        { id: 2, binding: 'lastPrice', header: t('tableHeader.price'), isVisible: true, width: '37.5%', align: 'right', sortable: false, clickable: true },
        { id: 3, binding: 'dailyChange', header: t('tableHeader.change'), template: '', isVisible: true, width: '37.5%', align: 'right', sortable: false, clickable: true },
    ];

    const columnsMostVolumeCard = [
        { id: 1, binding: 'symbolCode', header: t('tableHeader.code'), isVisible: true, width: '25%', align: 'left', sortable: false, clickable: true },
        { id: 2, binding: 'dailyValue', header: t('tableHeader.volume') + ' (Mln)', isVisible: true, width: '37.5%', align: 'right', sortable: false, clickable: true },
        { id: 3, binding: 'dailyChange', header: t('tableHeader.change'), template: '', isVisible: true, width: '37.5%', align: 'right', sortable: false, clickable: true },
    ];

    const columnsMostMarketValueCard = [
        { id: 1, binding: 'symbolCode', header: t('tableHeader.code'), isVisible: true, width: '22%', align: 'left', sortable: false, clickable: true },
        { id: 2, binding: 'marketCap', header: t('tableHeader.marketValue') + ' (Mln)', isVisible: true, width: '47%', align: 'right', sortable: false, clickable: true },
        { id: 3, binding: 'dailyChange', header: t('tableHeader.change'), template: '', isVisible: true, width: '31%', minWidth: '80px', align: 'right', sortable: false, clickable: true },
    ];

    const columnsDataHighestMarketCapitalization = [
        { id: 1, binding: 'symbolCode', header: t('tableHeader.code'), isVisible: true, align: 'left', sortable: false, clickable: true },
        { id: 2, binding: 'marketCap', header: t('tableHeader.marketValue') + ' (Mln)', isVisible: true, width: '50%', align: 'right', sortable: false, clickable: true },
        { id: 3, binding: 'dailyChange', header: t('tableHeader.change'), template: '', isVisible: true, width: '37.5%', align: 'right', sortable: false, clickable: true },
    ];

    const data = [
        {
            "id": 1,
            "Name": 'BIST Tüm',
            "Date": '06/04/2023',
            "change": -2,
            "last": 10,
            "price": 30,
            "code": "BISTTUM"
        },
        {
            "id": 2,
            "Name": 'BIST 100',
            "Date": '06/04/2023',
            "change": 2,
            "last": 10,
            "price": 30,
            "code": " BIST 100"
        },
        {
            "id": 3,
            "Name": 'BIST 30',
            "Date": '06/02/2023',
            "change": -3,
            "last": 10,
            "price": 30,
            "code": "BIST30"
        },
        {
            "id": 4,
            "Name": 'BIST Sigorta',
            "Date": '06/01/2023',
            "change": 5,
            "last": 10,
            "price": 30,
            "code": "BIST "
        },
        {
            "id": 5,
            "Name": 'BIST Holding ve Yatırım',
            "Date": '06/01/2023',
            "change": -5,
            "last": 10,
            "price": 30,
            "code": "BIST "
        },
        {
            "id": 6,
            "Name": 'BIST Katılım 30',
            "Date": '06/01/2023',
            "change": -3,
            "last": 10,
            "price": 30,
            "code": "BIST "
        },
        {
            "id": 7,
            "Name": 'BIST Temettü 25',
            "Date": '06/01/2023',
            "change": -2,
            "last": 10,
        },
        {
            "id": 8,
            "Name": 'BIST Gayrimenkul Yatırım Ortalaması',
            "Date": '06/01/2023',
            "change": 5,
            "last": 10,

        },
        {
            "id": 9,
            "Name": 'BIST Banka Dış Likit 10',
            "Date": '06/04/2023',
            "change": 4,
            "last": 10,

        },
        {
            "id": 10,
            "Name": 'BIST Likit Banka',
            "Date": '06/04/2023',
            "change": -3.5,
            "last": 10,
        },
        {
            "id": 11,
            "Name": 'BIST Tüm 100',
            "Date": '06/04/2023',
            "change": 2,
            "last": 10,
        },
        {
            "id": 12,
            "Name": 'BIST Holding ve Yatırım 2',
            "Date": '06/01/2023',
            "change": -4.5,
            "last": 10,
        },
        {
            "id": 13,
            "Name": 'BIST Katılım 10',
            "Date": '06/01/2023',
            "change": -2,
            "last": 10,
        },
        {
            "id": 14,
            "Name": 'BIST Temettü 11',
            "Date": '06/01/2023',
            "change": -1.5,
            "last": 10,
        },
    ];

    const gainersTableFields = ['best.dailyChange.101.1', 'best.dailyChange.101.2', 'best.dailyChange.101.3', 'best.dailyChange.101.4', 'best.dailyChange.101.5'];

    const losersTableFields = ['worst.dailyChange.101.1', 'worst.dailyChange.101.2', 'worst.dailyChange.101.3', 'worst.dailyChange.101.4', 'worst.dailyChange.101.5'];

    const highestMarketCapitalizationTableFields = ['best.marketCap.101.1', 'best.marketCap.101.2', 'best.marketCap.101.3', 'best.marketCap.101.4', 'best.marketCap.101.5', 'best.marketCap.101.6', 'best.marketCap.101.7', 'best.marketCap.101.8', 'best.marketCap.101.9', 'best.marketCap.101.10'];

    const highestTradingValueTableFields = ['best.dailyValue.101.1', 'best.dailyValue.101.2', 'best.dailyValue.101.3', 'best.dailyValue.101.4', 'best.dailyValue.101.5'];

    //#endregion TABLE COLUMNS & DATA
    useEffect(() => {
        getMarketSummaryData();
        getActionHubData();

        setSummaryTableColumnsData(summaryTableDataColumns);
        setColumnsChartViewData(summaryTableDataColumnsChartView);
        setColumnsDataMostCard(columnsMostCard);
        setDailyGainersTable(gainersTableFields);
        setDailyLosersTable(losersTableFields);
        setHighestMarketCapitalization(highestMarketCapitalizationTableFields);
        setHighestTradingValue(highestTradingValueTableFields);

    }, []);

    //#region FUNCTIONS

    const clickPeriod = (period) => {
        console.log(period);
        // activePeriod = period;
        setActivePeriod(period);

        if (isBetweenDateData) {
            setIsBetweenDateData(false);

            getMarketSummaryData();

        }
        const index = summaryTableChartData.findIndex((obj) => obj.field !== 'RocBetweenDate');

        if (index == -1) {
            getMarketSummaryData();
        }

        if (period == t('period.daily')) {
            // setSummaryTableColumnsData(summaryTableColumnsData);
            setSummaryTableColumnsData((prevData) => {
                const newData = [...prevData];
                prevData.forEach(obj => {
                    if (obj.field !== 'rocDailyChange' && obj.field !== 'name' && obj.field !== 'lastDay' && obj.field !== 'lastValue') {
                        obj.isVisible = false;
                    } else {
                        obj.isVisible = true;
                    }
                });

                setSummaryTableChartData((prevData) => {
                    const newData = [...prevData];
                    prevData.forEach(obj => {
                        obj.summaryChartValue = obj.rocDailyRaw;
                    });
                    return newData;
                });

                return newData;
            });
        } else if (period == t('period.weekly')) {
            setSummaryTableColumnsData((prevData) => {
                const newData = [...prevData];
                prevData.forEach(obj => {
                    if (obj.field !== 'rocWeeklyChange' && obj.field !== 'name' && obj.field !== 'lastDay' && obj.field !== 'lastValue') {
                        obj.isVisible = false;
                    } else {
                        obj.isVisible = true;
                    }
                });
                return newData;
            });

            setSummaryTableChartData((prevData) => {
                const newData = [...prevData];
                prevData.forEach(obj => {
                    obj.summaryChartValue = obj.rocWeeklyRaw;
                });
                return newData;
            });


        } else if (period == t('period.monthly')) {
            // summaryTableDataColumns.find(x => x.field == 'rocMonthly').isVisible = true;
            setSummaryTableColumnsData((prevData) => {
                const newData = [...prevData];
                prevData.forEach(obj => {
                    if (obj.field !== 'rocMonthlyChange' && obj.field !== 'name' && obj.field !== 'lastDay' && obj.field !== 'lastValue') {
                        obj.isVisible = false;
                    } else {
                        obj.isVisible = true;
                    }
                });
                return newData;
            });

            setSummaryTableChartData((prevData) => {
                const newData = [...prevData];
                prevData.forEach(obj => {
                    obj.summaryChartValue = obj.rocMonthlyRaw;
                });
                return newData;
            });
        } else if (period == t('period.ytd')) {
            setSummaryTableColumnsData((prevData) => {
                const newData = [...prevData];
                prevData.forEach(obj => {
                    if (obj.field !== 'rocYtdChange' && obj.field !== 'name' && obj.field !== 'lastDay' && obj.field !== 'lastValue') {
                        obj.isVisible = false;
                    } else {
                        obj.isVisible = true;
                    }
                });
                return newData;
            });

            setSummaryTableChartData((prevData) => {
                const newData = [...prevData];
                prevData.forEach(obj => {
                    obj.summaryChartValue = obj.rocYtdRaw;
                });
                return newData;
            });
        } else if (period == t('period.yearly')) {
            setSummaryTableColumnsData((prevData) => {
                const newData = [...prevData];
                prevData.forEach(obj => {
                    if (obj.field !== 'rocAnnualyChange' && obj.field !== 'name' && obj.field !== 'lastDay' && obj.field !== 'lastValue') {
                        obj.isVisible = false;
                    } else {
                        obj.isVisible = true;
                    }
                });
                return newData;
            });
            setSummaryTableChartData((prevData) => {
                const newData = [...prevData];
                prevData.forEach(obj => {
                    obj.summaryChartValue = obj.rocAnnualyRaw;
                });
                return newData;
            });
        } else if (period == 'Tarih Aralığı') {
            setSummaryTableColumnsData((prevData) => {
                const newData = [...prevData];
                prevData.forEach(obj => {
                    if (obj.field !== 'rocBetweenDateChange' && obj.field !== 'name' && obj.field !== 'lastDay' && obj.field !== 'lastValue') {
                        obj.isVisible = false;
                    } else {
                        obj.isVisible = true;
                    }
                });
                return newData;
            });
        }
    }


    const onClickViewChange = () => {
        setShowTable(!showTable);
    }

    //#endregion FUNCTIONS

    //#region  DATE PICKER

    const selectedDate = (firstDate, lastDate) => {
        try {
            console.log('firstDate: ' + firstDate);
            console.log('lastDate: ' + lastDate);


            firstDate = dateFormatter.dateToInt(firstDate);
            lastDate = dateFormatter.dateToInt(lastDate);

            getMarketSummaryBetweenDateData(firstDate, lastDate);

            clickPeriod('Tarih Aralığı');

        } catch (error) {
            console.log(error);
        }
    }

    //#endregion DATE PICKER

    //#region API CALLS


    //#region ACTIONHUB

    const getActionHubData = () => {

        // let identityToken = user["TokenId"];

        // apiActionHub.actionhubQuarterGet({ entityId: 'sec.101.14', token: token }, { mode: 'no-cors' }).then((res) => {
        //
        //     console.log(res);
        // }).catch((err) => {
        //     console.log(err);
        // });
    }

    //#endregion ACTIONHUB

    //#region MARKETSUMMARY

    const getMarketSummaryData = () => {
        setIsLoadingTable(true);

        marketApi.marketMarketsummaryFetchGet(token, false).then((res) => {

            console.log(res);
            const data = res.data.marketSummaries;
            setMarketSummariesServiceData(res.data.marketSummaries);

            for (let index = 0; index < data.length; index++) {

                const element = data[index];
                // element.lastDay = element.lastDay.day + '/' + element.lastDay.month + '/' + element.lastDay.year;
                // element.lastValue = element.lastValue;
                element.rocDailyRaw = element.rocDaily;
                element.rocWeeklyRaw = element.rocWeekly;
                element.rocMonthlyRaw = element.rocMonthly;
                element.rocYtdRaw = element.rocYtd;
                element.rocAnnualyRaw = element.rocAnnualy;

                if (activePeriod == t('period.daily')) { //açılışta günlük seçili gelsin
                    element.summaryChartValue = element.rocDailyRaw;
                } else if (activePeriod == t('period.weekly')) {
                    element.summaryChartValue = element.rocWeeklyRaw;
                } else if (activePeriod == t('period.monthly')) {
                    element.summaryChartValue = element.rocMonthlyRaw;
                } else if (activePeriod == t('period.ytd')) {
                    element.summaryChartValue = element.rocYtdRaw;
                } else if (activePeriod == t('period.yearly')) {
                    element.summaryChartValue = element.rocAnnualyRaw;
                }
                else if (activePeriod == 'Tarih Aralığı') {
                    element.summaryChartValue = element.rocBetweenDate;
                }

                element.lastValue = numberFormatter.Double(element.lastValue, 2);
                element.rocDailyChange = numberFormatter.Double(element.rocDaily, 2);
                element.rocWeeklyChange = numberFormatter.Double(element.rocWeekly, 2);
                element.rocMonthlyChange = numberFormatter.Double(element.rocMonthly, 2);
                element.rocYtdChange = numberFormatter.Double(element.rocYtd, 2);
                element.rocAnnualyChange = numberFormatter.Double(element.rocAnnualy, 2);
                element.rocBetweenDateChange = numberFormatter.Double(element.rocBetweenDate, 2);
                element.lastDay = dateFormatter.intToDate(element.lastDay);
                element.date = typeof (element.lastDay) == 'string' ? element.lastDay : dateFormatter.intToDate(element.lastDay);

            }

            // setSummaryTableChartData(data);
            setSummaryTableChartData((prevData) => {
                if (prevData.length != 0) {
                    prevData.forEach(obj => {
                        let item = data.find(x => x.entityId == obj.entityId);

                        obj.rocDailyChange = item ? item.rocDailyChange : 0;
                        obj.rocWeeklyChange = item ? item.rocWeeklyChange : 0;
                        obj.rocMonthlyChange = item ? item.rocMonthlyChange : 0;
                        obj.rocYtdChange = item ? item.rocYtdChange : 0;
                        obj.rocAnnualyChange = item ? item.rocAnnualyChange : 0;
                        obj.rocBetweenDateChange = item ? item.rocBetweenDateChange : 0;

                        if (activePeriod != 'Tarih Aralığı') {
                            obj.summaryChartValue = item ? item.summaryChartValue : 0;
                            obj.rocBetweenDateRaw = item ? item.rocBetweenDateRaw : 0;
                        }

                    });
                }
                else {
                    prevData = data;
                }

                return prevData;
            }
            );

            setTimeout(() => {
                setIsLoadingTable(false);
            }, 1000);
        }).catch((err) => {
            console.log(err);
        });
    }

    //#endregion MARKETSUMMARY 

    //#region MARKETSUMMARY BETWEEN DATES
    const getMarketSummaryBetweenDateData = (date1, date2) => {
        setIsLoadingTable(true);

        marketApi.marketMarketsummarydateFetchGet(token, false, date1, date2).then((res) => {

            console.log('marketMarketsummarydateFetchGet' + ' :', res);
            let data = res.data.marketSummariesDate;
            setMarketSummariesServiceData(res.data.marketSummariesDate);

            for (let index = 0; index < data.length; index++) {

                const element = data[index];
                // element.lastDay = element.lastDay.day + '/' + element.lastDay.month + '/' + element.lastDay.year;
                // element.lastValue = element.lastValue;
                element.rocBetweenDateRaw = element.rocBetweenDate;
                element.summaryChartValue = element.rocBetweenDate;

                element.lastValue = numberFormatter.Double(element.lastValue, 2);
                element.rocBetweenDateChange = numberFormatter.Double(element.rocBetweenDate, 2);
                element.lastDay = dateFormatter.intToDate(element.lastDay);
                element.date = typeof (element.lastDay) == 'string' ? element.lastDay : dateFormatter.intToDate(element.lastDay);

            }



            setSummaryTableChartData((prevData) => {
                const newData = [...prevData];

                prevData.forEach(obj => {
                    let item = data.find(x => x.entityId == obj.entityId);
                    obj.rocBetweenDateChange = item ? item.rocBetweenDateChange : 0;
                    obj.summaryChartValue = item ? item.summaryChartValue : 0;
                    obj.rocBetweenDateRaw = item ? item.rocBetweenDateRaw : 0;
                    obj.rocBetweenDate = item ? item.rocBetweenDateRaw : 0;

                });
                return newData;


                // if (prevData.length != 0) {
                //     prevData.forEach(obj => {
                //         let item = data.find(x => x.entityId == obj.entityId);

                //         obj.rocBetweenDateChange = item ? item.rocBetweenDateChange : 0;
                //         obj.summaryChartValue = item ? item.summaryChartValue : 0;
                //         obj.rocBetweenDateRaw = item ? item.rocBetweenDateRaw : 0;
                //         // obj.rocBetweenDate = item ? item.rocBetweenDateRaw : 0;


                //     });
                // }
                // else {
                //     prevData = data;
                // }
                // return prevData;


            });


            setIsBetweenDateData(true);



            setTimeout(() => {
                setIsLoadingTable(false);
            }, 1000);
        }).catch((err) => {
            console.log(err);
        });
    }

    //#endregion MARKETSUMMARY BETWEEN DATES

    //#endregion API CALLS

    return (
        <div className='market-summary-screen'>
            <Toast ref={toast} position={'bottom-right'} />
            {/* LiveTickerBar */}
            <Container>
                <Row>
                    <Col>
                        <LiveTickerBar />
                    </Col>
                </Row>
            </Container>
            {/* LiveTickerBar */}


            {/* PERIOD SELECTION & OPTIONS */}
            <div className='options-row m-b-20 m-t-15'>
                <PeriodSelection periods={periods} activePeriod={activePeriod} clickPeriod={clickPeriod} />
                <MultipleDatePicker selectedDate={selectedDate} firstDate={firstDate} lastDate={lastDate} />

                <div className='table-chart-icon-bg' onClick={onClickViewChange}>
                    {!showTable ? <FontAwesomeIcon className='table-chart-icon' icon={faTable} /> :
                        <FontAwesomeIcon className='table-chart-icon' icon={faChartSimpleHorizontal} />}
                </div>
            </div>
            {/* PERIOD SELECTION & OPTIONS */}


            {/* TABLE */}
            {
                showTable &&
                <div className='table-chart-view market-summary-table'>

                    {isLoadingTable && <Spinner height="400px" />}
                    {!isLoadingTable &&
                        <DataTableComponent columnsProp={summaryTableColumnsData} dataProp={summaryTableChartData}
                            search={false} columnsSelect={false} />
                    }

                </div>
            }
            {/* TABLE */}


            {/* CHART */}
            {
                !showTable &&
                <>
                    {/* <DataTableComponent columnsProp={columnsData} dataProp={tableData} search={false} columnsSelect={false} />

                    <StackedBarChart data={tableData} /> */}
                    <Container className='chart-view '>
                        <Row>
                            <Col md='5' className='p-0 chart-view-table'>
                                <DataTableComponent
                                    columnsProp={summaryTableDataColumnsChartView}
                                    dataProp={summaryTableChartData}
                                    columnsSelect={false}
                                    search={false} />
                            </Col>

                            <Col md='7' className='p-0 chart-view-chart' >
                                {/* CHART */}
                                <StackedBarChart data={summaryTableChartData}
                                    valueXField={'summaryChartValue'}
                                    categoryYField={'code'} hideLabel={false}
                                    selectedPeriod={activePeriod} />
                                {/* CHART */}
                            </Col>

                        </Row>
                    </Container>
                </>
            }
            {/* CHART */}

            <div className='m-t-20'>
                {/* DATE SELCTION & OPTIONS */}
                {/* <MultipleDatePicker substract={12} selectedDate={selectedDate} selectedDateLast={selectedDateLast} /> */}
                {/* DATE SELCTION & OPTIONS */}
            </div>


            {/* EN ÇOK */}
            <div className='most-info-cards-container  transition'>
                <BestWorstHigh title={t('marketSummary.bestWorstHighTitle1')} objectIds={gainersTableFields} columns={columnsMostCard} sortField={"dailyChange"} sortOrder={-1} />
                <BestWorstHigh title={t('marketSummary.bestWorstHighTitle2')} objectIds={losersTableFields} columns={columnsMostCard} sortField={"dailyChange"} sortOrder={-1} />
                <BestWorstHigh title={t('marketSummary.bestWorstHighTitle3')} objectIds={highestMarketCapitalizationTableFields} columns={columnsMostMarketValueCard} sortField={"marketCap"} sortOrder={-1} />
                <BestWorstHigh title={t('marketSummary.bestWorstHighTitle4')} objectIds={highestTradingValueTableFields} columns={columnsMostVolumeCard} sortField={"dailyValue"} sortOrder={-1} />
            </div>
            {/* EN ÇOK */}
        </div>
    )
}


export default MarketSummary;
